module.exports = __webpack_public_path__ + "static/img/img_tip5.15b4e8fe.png";